import { NavMenuDivider, NavMenuItem, NavMenuSection } from '@sailadv/hdata-ui';
import { Fragment, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { matchPath, useLocation } from 'react-router-dom';

import { useHasMultipleEntities } from '@/entities/boat';
import { navigationList } from '@/entities/navigation/model/constants/navigation-list';
import { useRoutes } from '@/entities/navigation/model/hooks/use-routes.hook';
import { useAutomatedPlanAccess, useIsPlant, useMultiI18nKeys } from '@/entities/user';
import { useAppPrefix } from '@/shared/lib/hooks/use-app-prefix.hook';

const NavigationMenuComponent = ({ close }: { close?: () => void }) => {
	const { t } = useTranslation('common');
	const { pathname } = useLocation();
	const prefix = useAppPrefix();
	const isPlant = useIsPlant();
	const automatedPlanAccess = useAutomatedPlanAccess();
	const hasMultipleEntities = useHasMultipleEntities();
	const dynamicRoutes = useRoutes();
	const keys = useMultiI18nKeys();

	return (
		<>
			{navigationList.map(({ dynamicTitle, routes, title }, index) => {
				const sectionTitle = dynamicTitle?.(isPlant) ?? title;

				return (
					<Fragment key={`${sectionTitle}_${index}`}>
						{index > 0 && <NavMenuDivider />}
						{sectionTitle && <NavMenuSection>{t(sectionTitle)}</NavMenuSection>}
						{routes
							.filter(({ canShow }) => (canShow ? canShow(isPlant, hasMultipleEntities, automatedPlanAccess) : true))
							.map(({ dynamicHref, dynamicLabel, href, label, Icon }) => {
								const route = `${prefix}${dynamicHref?.(dynamicRoutes) ?? href}`;
								const i18nKey = dynamicLabel?.(keys) || label;
								const active = Boolean(matchPath({ path: route, end: false }, pathname));

								return (
									<NavMenuItem key={i18nKey} href={route} active={active} icon={<Icon />} onPress={close}>
										{t(i18nKey)}
									</NavMenuItem>
								);
							})}
					</Fragment>
				);
			})}
		</>
	);
};

export default memo(NavigationMenuComponent);
